import { useEffect, useRef } from 'react'
import { MapPin } from 'lucide-react'

interface LocationConsentDialogProps {
  isOpen: boolean
  onAccept: () => void
  onClose: () => void
}

export function LocationConsentDialog({
  isOpen,
  onAccept,
  onClose,
}: LocationConsentDialogProps) {
  const acceptButtonRef = useRef<HTMLButtonElement>(null)

  useEffect(() => {
    if (!isOpen) return undefined

    acceptButtonRef.current?.focus()

    function handleKeyDown(event: KeyboardEvent) {
      if (event.key === 'Escape') onClose()
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [isOpen, onClose])

  if (!isOpen) return null

  return (
    <div
      className="reporting-location-dialog"
      role="dialog"
      aria-modal="true"
      aria-labelledby="global-location-title"
    >
      <div className="reporting-location-dialog__panel">
        <span className="reporting-location-dialog__icon" aria-hidden="true">
          <MapPin />
        </span>
        <div>
          <p>Tu territorio</p>
          <h2 id="global-location-title">Mira la información de tu ubicación</h2>
          <span>
            Usaremos tu ubicación aproximada para mostrar información de tu ciudad. No guardamos
            ni enviamos tus coordenadas.
          </span>
        </div>
        <div className="reporting-location-dialog__actions">
          <button type="button" className="reporting-location-dialog__secondary" onClick={onClose}>
            Ahora no
          </button>
          <button
            ref={acceptButtonRef}
            type="button"
            className="reporting-location-dialog__primary"
            onClick={onAccept}
          >
            Usar mi ubicación
          </button>
        </div>
      </div>
    </div>
  )
}
